import { merge } from '../../../helper';

import { create as createTable } from '../create';

// ----------------------------------------------------------------------------

function create(config: Record<string, any> = {}): HTMLElement {
    const defConfig: Record<string, any> = {
        rowCount: 3,
        columnCount: 3,
    };

    merge(defConfig, config);

    const tableLayout = createTable({
        class: {
            new: 'table-layout',
        },
        layout: {
            rowCount: defConfig.rowCount,
            columnCount: defConfig.columnCount,
        },
        display: false,
    });

    if (typeof defConfig.fnAction === 'function') {
        tableLayout.element.addEventListener('click', function (evt): any {
            const elColumn = evt.target instanceof HTMLElement ? evt.target.closest('td') : null;

            if (!(elColumn instanceof HTMLTableCellElement)) {
                return;
            }

            const elRow = elColumn.parentElement;

            if (!(elRow instanceof HTMLTableRowElement)) {
                return;
            }

            defConfig.fnAction({
                rowCount: elRow.rowIndex + 1,
                columnCount: elColumn.cellIndex + 1,
            });
        });
    }

    return tableLayout.element;
}

// ----------------------------------------------------------------------------

export { create };
